export default __webpack_public_path__ + "static/media/HealthBridge.229ce17f.svg";